/**
 * invokes toast popup with a given type and text
 * @param {String} type - The type of toast to display, e.g. 'success', 'error' Default is 'success'
 * @param {String} text - The text to display in the toast
*/

function toast({
  type = 'success',
  text,
}) {
  const toastType = `app:notification:flash:${type}`

  if (type && text) {
    return App.events.publish(toastType, text)
  }

  return null

}

export default toast
